/* Aromante · Pop up de búsqueda: reemplaza el buscador del tema en la lupa del header */
(function () {
  if (customElements.get('aro-search-popup')) return;

  const TRIGGERS = '.header__icon--search, [data-aro-search-open]';

  class AroSearchPopup extends HTMLElement {
    connectedCallback() {
      this.panel = this.querySelector('.aro-sp__panel');
      this.form = this.querySelector('[data-sp-form]');
      this.input = this.querySelector('[data-sp-input]');
      this.catalog = this.dataset.catalog || '/collections/all';

      this.onTrigger = (e) => {
        const t = e.target.closest(TRIGGERS);
        if (!t || this.contains(t)) return;
        e.preventDefault();
        e.stopPropagation();
        const inDrawer = this.closeDrawer();
        const details = t.closest('details');
        if (details && !t.closest('header-drawer')) details.removeAttribute('open');
        this.open(inDrawer ? document.querySelector('header-drawer summary') : t);
      };
      document.addEventListener('click', this.onTrigger, true);

      this.querySelectorAll('[data-sp-close]').forEach((el) => el.addEventListener('click', () => this.close()));
      this.addEventListener('keydown', (e) => this.onKey(e));
      this.form.addEventListener('submit', (e) => this.submit(e));
      this.querySelectorAll('[data-sp-term]').forEach((chip) => {
        chip.addEventListener('click', (e) => {
          if (this.searchInPlace(chip.dataset.spTerm)) e.preventDefault();
        });
      });

      /* Editor de temas: abrirlo al seleccionar la sección o un bloque */
      if (this.dataset.designMode === 'true') {
        this.onSelect = (e) => { if (this.closest('.shopify-section') && this.closest('.shopify-section').id === 'shopify-section-' + e.detail.sectionId) this.open(); };
        this.onDeselect = (e) => { if (this.closest('.shopify-section') && this.closest('.shopify-section').id === 'shopify-section-' + e.detail.sectionId) this.close(); };
        document.addEventListener('shopify:section:select', this.onSelect);
        document.addEventListener('shopify:block:select', this.onSelect);
        document.addEventListener('shopify:section:deselect', this.onDeselect);
      }
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onTrigger, true);
      if (this.onSelect) {
        document.removeEventListener('shopify:section:select', this.onSelect);
        document.removeEventListener('shopify:block:select', this.onSelect);
        document.removeEventListener('shopify:section:deselect', this.onDeselect);
      }
      document.documentElement.classList.remove('aro-sp-lock');
    }

    /* Cierra el menú lateral del tema si está abierto (para que nunca haya dos pop ups) */
    closeDrawer() {
      const hd = document.querySelector('header-drawer');
      const open = hd && hd.querySelector(':scope > details[open]');
      if (!open) return false;
      if (typeof hd.closeMenuDrawer === 'function') hd.closeMenuDrawer(new Event('aro-close'), false);
      else open.removeAttribute('open');
      const sum = open.querySelector(':scope > summary');
      if (sum) sum.setAttribute('aria-expanded', 'false');
      return true;
    }

    open(trigger) {
      if (this.isOpen) return;
      this.isOpen = true;
      this.returnFocus = trigger || document.activeElement;
      clearTimeout(this.hideTimer);
      this.hidden = false;
      document.documentElement.classList.add('aro-sp-lock');
      requestAnimationFrame(() => {
        this.classList.add('is-open');
        const current = new URLSearchParams(window.location.search).get('q');
        if (current && !this.input.value) this.input.value = current;
        this.input.focus({ preventScroll: true });
      });
    }

    close() {
      if (!this.isOpen) return;
      this.isOpen = false;
      this.classList.remove('is-open');
      document.documentElement.classList.remove('aro-sp-lock');
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.hideTimer = setTimeout(() => { this.hidden = true; }, reduce ? 0 : 420);
      if (this.returnFocus && typeof this.returnFocus.focus === 'function') {
        this.returnFocus.focus({ preventScroll: true });
      }
    }

    onKey(e) {
      if (e.key === 'Escape') { e.preventDefault(); this.close(); return; }
      if (e.key !== 'Tab') return;
      const items = Array.from(this.panel.querySelectorAll('a[href], button, input')).filter((el) => el.offsetParent !== null);
      if (!items.length) return;
      const first = items[0];
      const last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    submit(e) {
      const term = this.input.value.trim();
      if (!term) { e.preventDefault(); this.input.focus(); return; }
      if (this.searchInPlace(term)) e.preventDefault();
    }

    /* Si ya estamos en el catálogo, filtra ahí mismo sin recargar */
    searchInPlace(term) {
      const catalogEl = document.querySelector('aro-catalog');
      if (!catalogEl) return false;
      let target;
      try { target = new URL(this.catalog, window.location.origin).pathname.replace(/\/$/, ''); } catch (err) { return false; }
      const here = window.location.pathname.replace(/\/$/, '');
      if (target !== here) return false;
      this.input.value = term;
      this.close();
      document.dispatchEvent(new CustomEvent('aro:search', { detail: { q: term } }));
      return true;
    }
  }

  customElements.define('aro-search-popup', AroSearchPopup);
})();
